import React from "react";

export const DashboardSectionCard = ({
  title,
  subtitle,
  filters,
  children,
  className = "",
}) => (
  <section className={`pd-section ${className}`.trim()}>
    {title || filters ? (
      <div className="pd-section-head">
        {title ? <h6 className="pd-section-title">{title}</h6> : null}
        {filters}
      </div>
    ) : null}
    {subtitle ? <div className="pd-section-subtitle">{subtitle}</div> : null}
    {children}
  </section>
);

export default DashboardSectionCard;
